import React, { useEffect, useState } from 'react';
import {
  Modal,
  Form,
  Row,
  notification,
  Input,
  Col,
  Button,
  Typography,
  Card,
} from 'antd';

import GetLabel from 'DisplayFramework/components/GetLabel';
import { useForm } from 'antd/lib/form/Form';
import FormInput from 'components/FormInput';
import { isNil } from 'lodash';
import { AimOutlined } from '@ant-design/icons';

import {
  AssetAddress,
  getAssetAddresById,
  updateAssetAddres,
} from 'services/assets';

import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import { useQuery } from 'react-query';
import Address from 'components/address/Address';
import AssetAddresStatusButton from './AssetAddresStatusButton';
import SaveButton from 'components/SaveButtonTabsTop';
import ParListSelect from 'components/ParListSelect';
import UtinaCard from 'components/UtinaCard';
import getEnvValue from 'utils/getEnvValue';
export type marker = {
  lat: number;
  lng: number;
};
type AssetAdressModalProps = {
  visible: boolean;
  onClose: () => void;
  assetadrid: number;
  assetid: number;
  refetech: () => void;
  pickPlace: boolean;
  setpickPlace: any;
  position: marker;
  setisLoading: any;
  isLoading: boolean;
};

const initialValues = {
  adrenddate: '' as any,
  adrstartdate: '' as any,
  adrstatus: '' as any,
  adrstatusdate: '' as any,
  adrtype: '' as any,
  assetadrid: '' as any,
  assetid: '' as any,
  assetmainadrcity: '' as any,
  assetmainadrcountry: '' as any,
  assetmainadrregion: '' as any,
  assetmainadrstreet1: '' as any,
  assetmainadrstreet2: '' as any,
  assetmainadrzipcode: '' as any,
  assetgpslng: '' as any,
  assetgpslat: '' as any,
};
const AssetAdressModal = (props: AssetAdressModalProps) => {
  const {
    visible,
    onClose,
    assetadrid,
    assetid,
    refetech: refetechprop,
    pickPlace,
    setpickPlace,
    position,
    setisLoading,
    isLoading,
  } = props;
  const { data, refetch, isFetching } = useQuery(
    ['getAssetAddresById', { assetadrid, assetid }],
    () =>
      getAssetAddresById({ assetadrid, assetid }).then((res) => res.data || {}),
    {
      staleTime: 60 * 1000,
      enabled: !isNil(assetid),
    }
  );
  const [closed, setClosed] = useState(false);
  const [form] = useForm();

  useEffect(() => {
    if (data) form.setFieldsValue({ ...data });
    if (position.lat !== 0 && position.lng !== 0)
      form.setFieldsValue({
        assetgpslng: position?.lng,
        assetgpslat: position?.lat,
      });
  }, [data, form, position.lat, position.lng]);

  const onfinish = async (values: any) => {
    const assetAddressRequest: AssetAddress = {
      adrenddate: data?.adrenddate ?? ('' as any),
      adrstartdate: data?.adrstartdate ?? ('' as any),
      adrstatus: data?.adrstatus ?? ('' as any),
      adrstatusdate: data?.adrstatusdate ?? ('' as any),
      adrtype: values?.adrtype ?? ('' as any),
      assetadrid,
      assetid,
      assetmainadrcity: values.assetmainadrcity ?? ('' as any),
      assetmainadrcountry: values.assetmainadrcountry ?? ('' as any),
      assetmainadrregion: values.assetmainadrregion ?? ('' as any),
      assetmainadrstreet1: values.assetmainadrstreet1 ?? ('' as any),
      assetmainadrstreet2: values.assetmainadrstreet2 ?? ('' as any),
      assetmainadrzipcode: values.assetmainadrzipcode ?? ('' as any),
      assetgpslng: form.getFieldValue('assetgpslng'),
      assetgpslat: form.getFieldValue('assetgpslat'),
    };
    await updateAssetAddres({
      assetid,
      assetadrid,
      assetAddressRequest,
    })
      .then((res) => {
        if (res.code === '200') {
          notification.success({ message: res.message });
          refetch();
          refetechprop();
          setisLoading(false);
          setpickPlace(false);
          setClosed(true);
        }
      })
      .catch((res) => {
        notification.error({ message: res.message });
        setisLoading(false);
      });
  };

  return (
    (<Modal
      mask={false}
      open={visible && !closed}
      onCancel={onClose}
      width={700}
      style={!getEnvValue('hideMaps')?{ top: 193, position: 'absolute', right: 0 }:{}}
      title={<GetLabel label="UpdateAdressDetail" />}
      footer={
        <Row justify="center">
          <Col>
            <AssetAddresStatusButton
              assetid={assetid}
              assetadrid={assetadrid}
              status={data?.adrstatus ?? ''}
              refetch={() => {
                refetch();
                refetechprop();
              }}
            />
          </Col>
          <Col span={4}>
            <SaveButton onClick={() => form.submit()} comcode="update" />
          </Col>
        </Row>
      }
      destroyOnClose
    >
      <Card>
        <Form
          form={form}
          preserve={false}
          layout="vertical"
          initialValues={initialValues}
          labelCol={{ span: 24 }}
          onFinishFailed={onFinishFailed}
          onFinish={onfinish}
        >
          <Row gutter={8}>
            <Col span={16}>
              <UtinaCard
                comcode="updateadresse"
                level={5}
                styleCard={{ height: '100%' }}
              >
                <Row>
                  <FormInput col xs={12} name="adrtype">
                    <ParListSelect parcode="ADRTYPE" />
                  </FormInput>
                </Row>
                <Row gutter={16}>
                  <FormInput col xs={12} name="assetmainadrstreet1">
                    <Input />
                  </FormInput>

                  <FormInput col xs={12} name="assetmainadrstreet2">
                    <Input />
                  </FormInput>
                </Row>
                <Row gutter={16}>
                  <Address
                    hideRegionGlobal
                    form={form}
                    spanCity={12}
                    spanRegion={12}
                    spanZip={12}
                    spanCountry={12}
                    paysField="assetmainadrcountry"
                    regionField="assetmainadrregion"
                    villeField="assetmainadrcity"
                    codePostalField="assetmainadrzipcode"
                  />
                </Row>
              </UtinaCard>
            </Col>
            <Col span={8}>
              <UtinaCard
                comcode="updatelocation"
                level={5}
                styleCard={{ height: '100%' }}
              >
                {' '}
                <Button
                  onClick={() => {
                    setpickPlace(!pickPlace);
                  }}
                  loading={pickPlace}
                  type="primary"
                  shape="circle"
                  icon={<AimOutlined />}
                  style={{ float: 'left' }}
                />
                <Typography.Paragraph italic>
                  {' '}
                  &nbsp;please click on target button to pick place
                </Typography.Paragraph>
                <Typography.Paragraph italic>
                  {' '}
                  &nbsp;Or fill the fields
                </Typography.Paragraph>
                <FormInput col xs={24} name="assetgpslng">
                  <Input style={{ width: '100%' }} />
                </FormInput>
                <FormInput col xs={24} name="assetgpslat">
                  <Input style={{ width: '100%' }} />
                </FormInput>
              </UtinaCard>
            </Col>
          </Row>
        </Form>
      </Card>
    </Modal>)
  );
};

export default AssetAdressModal;
